import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { BASE_URL, IMAGE_URL, security_key } from "../../global";

import news from "../../Assets/img/newsimg/news.jpeg";
import news5 from "../../Assets/img/newsimg/news5.png";
import news6 from "../../Assets/img/newsimg/news6.png";
import news7 from "../../Assets/img/newsimg/news7.png";
import news8 from "../../Assets/img/newsimg/news-8.webp";
import news9 from "../../Assets/img/newsimg/news-9.webp";

import axios from "axios";

// const posts = [
//   {
//     img: news,
//     title: "America’s Governors Get Tested for a Virus That Is Testing Them",
//     date: "25 Jun",
//     views: "126k Views",
//   },
//   {
//     img: news5,
//     title:
//       "Bartering Child’s Dress for Food: Life in Lebanon’s Economic Crisis",
//     date: "25 April",
//     views: "37k Views",
//   },
//   {
//     img: news6,
//     title:
//       "Cairo Badly Needed a Detox. Lockdown Supplied One, at a Steep Price.",
//     date: "25 April",
//     views: "54k Views",
//   },
//   {
//     img: news7,
//     title:
//       "Eating Thai Fruit Demands Serious Effort but Delivers Sublime Reward",
//     date: "25 April",
//     views: "54k Views",
//   },
//   {
//     img: news8,
//     title: "In Iraq, a New Prime Minister Takes Stock of His Bloodied Land",
//     date: "25 April",
//     views: "54k Views",
//   },
// ];

// const categories = [
//   {
//     title: "World News",
//     subCategories: [
//       "Africa",
//       "Americas",
//       "Asia",
//       "Canada",
//       "Europe",
//       "Middle East",
//     ],
//   },
//   {
//     title: "Business",
//     subCategories: [
//       "DealBook",
//       "Economy",
//       "Energy",
//       "Markets",
//       "Media",
//       "Your Money",
//       "Automobiles",
//     ],
//   },
//   {
//     title: "Sports News",
//     subCategories: [
//       "Baseball",
//       "Football",
//       "Golf",
//       "Hockey",
//       "Soccer",
//       "Tennist",
//       "Marathon",
//     ],
//   },
//   {
//     title: "Video News",
//     subCategories: [
//       "Politics",
//       "International",
//       "Business",
//       "Tech",
//       "Culture",
//       "Style",
//       "Health",
//       "Sports",
//       "Travel",
//       "Science",
//     ],
//   },
// ];

const SideBar = () => {
    const [openCategories, setOpenCategories] = useState({});
    const [isSidebarOpen, setSidebarOpen] = useState(false);
    const [categories, setCategories] = useState([]);
    const [post, setPost] = useState([]);
    const [highlightData, setHighlightData] = useState([]);

    useEffect(() => {
        getHighlightAndTrendArticle();
    }, []);

    useEffect(() => {
        getAllNavCategory();
    }, []);

    const getAllNavCategory = async () => {
        const response = await axios.post(BASE_URL + "API/apicall", {
            security_key: security_key,
            mode: "getAllNavCategory",
        });

        const output = response.data;

        if (output.length > 0) {
            setCategories(output);
        }
    };

    const toggleSidebar = () => {
        setSidebarOpen(!isSidebarOpen);
    };

    const toggleCategory = (index) => {
        setOpenCategories((prev) => ({
            ...prev,
            [index]: !prev[index],
        }));
    };

    const getHighlightAndTrendArticle = async () => {
        try {
            const response = await axios.post(BASE_URL + "API/apicall", {
                security_key: security_key,
                mode: "getHighlightAndTrendArticle",
            });
            const output = response.data;
            if (Object.keys(output).length == 2) {
                setHighlightData(output.highlight_news);
                setPost(output.trend_news);
                // alert(JSON.stringify(output.highlight_news));
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    return (
        <div className="">
            <div className="">
                <aside>
                    <button
                        class="btn-topbar btn btn-transparent pt-2"
                        type="button"
                        data-bs-toggle="offcanvas"
                        data-bs-target="#offcanvasWithBothOptions"
                        aria-controls="offcanvasWithBothOptions"
                    >
                        <i class="ti-view-grid f-13"></i>
                    </button>

                    <div
                        class="offcanvas offcanvas-end"
                        data-bs-scroll="true"
                        tabindex="-1"
                        id="offcanvasWithBothOptions"
                        aria-labelledby="offcanvasWithBothOptionsLabel"
                    >
                        <div class="offcanvas-header">
                            <h5 class="offcanvas-title" id="offcanvasWithBothOptionsLabel">
                                Don't Miss
                            </h5>
                            <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                        </div>
                        <div class="offcanvas-body">
                            <ul className="list-post">
                                {post.map((post, index) => (
                                    <li className="mb-15 nav-item" key={index}>
                                        <div className="d-flex">
                                            <div className="post-thumb post-thumb-80 d-flex mr-15 border-radius-5 img-hover-scale">
                                                <a className="color-white" href="">
                                                    {post.additionalFields &&
                                                        JSON.parse(post.additionalFields).map((item, index) => {
                                                            if (index == 0) {
                                                                return item["base_type"] === "video" ? (
                                                                    <></>
                                                                ) : (
                                                                    <img
                                                                        src={IMAGE_URL + item["file_name"]}
                                                                        className="img-fluid"
                                                                        width={80}
                                                                        height={80}
                                                                        alt=""
                                                                    />
                                                                );
                                                            }
                                                        })}
                                                </a>
                                            </div>
                                            <div className="post-content media-body text-start">
                                                <h6 className="post-title mb-10 text-limit-2-row">
                                                    <Link to={"/detail/" + post.pk_ac_key}>{post.ac_name}</Link>
                                                </h6>
                                                <div className="entry-meta meta-1 font-x-small color-grey">
                                                    <span className="post-on">{post.mod_publish_date}</span>
                                                    <span className="hit-count has-dot">{post.ac_view_count}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                ))}
                            </ul>

                            <div className="sidebar-widget widget_categories mt-50">
                                <div className="widget-header position-relative">
                                    <h5 className="widget-title mt-5 text-start">All Sections</h5>
                                </div>
                                <div className="widget_nav_menu">
                                    <ul className="menu text-start">
                                        {categories.map((category, index) => (
                                            <li
                                                // className="cat-item cat-item-2 menu-item-has-children"
                                                style={{ cursor: "pointer" }}
                                                key={index}
                                                onClick={() => toggleCategory(index)}
                                            >
                                                <Link to={`/category/${category.pk_cat_key}`}>{category.cat_name}</Link>
                                                {/* {openCategories[index] && (
                          <ul className="sub-menu">
                            {category.subCategories.map(
                              (subCategory, subIndex) => (
                                <li className="cat-item" key={subIndex}>
                                  <Link href="/home">{subCategory}</Link>
                                </li>
                              )
                            )}
                          </ul>
                        )} */}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </aside>
            </div>
            <style jsx>
                {`
                    .btn-topbar {
                        border: unset !important;
                    }
                `}
            </style>
        </div>
    );
};

export default SideBar;
